import { Arrow } from './Arrow';

function ServiceArt({ index, dark }) {
  if (index === 0) {
    // Product design — layered UI
    return (
      <div className="art art-stack">
        <div className="art-card art-card-back" data-tilt="0.4">
          <div className="art-card-row" />
          <div className="art-card-row sm" />
          <div className="art-card-row sm" />
          <div className="art-card-grid">
            <span /><span /><span /><span /><span /><span />
          </div>
        </div>
        <div className="art-card art-card-mid" data-tilt="0.7">
          <div className="art-pill"><span className="dot-orange"></span>Pricing flow · v4</div>
          <div className="art-bigprice">$12<span>/mo</span></div>
          <div className="art-rows">
            <div className="art-row">Unlimited boards</div>
            <div className="art-row">3 collaborators</div>
            <div className="art-row">Version history (30d)</div>
          </div>
        </div>
        <div className="art-card art-card-front" data-tilt="1">
          <div className="art-front-head">
            <span className="art-avatar"></span>
            <div>
              <div className="art-front-title">Onboarding · 04 of 06</div>
              <div className="art-front-sub">Pick your starter workspace</div>
            </div>
          </div>
          <div className="art-options">
            <div className="art-option active">
              <span className="art-opt-emoji">◐</span>
              <div>
                <strong>Solo</strong>
                <span>Just me, for now</span>
              </div>
            </div>
            <div className="art-option">
              <span className="art-opt-emoji">◑</span>
              <div>
                <strong>Team</strong>
                <span>Bring my collaborators</span>
              </div>
            </div>
          </div>
          <div className="art-front-foot">
            <span className="kbd">↵ Continue</span>
          </div>
        </div>
      </div>
    );
  }
  
  if (index === 1) {
    // Design systems — token grid
    return (
      <div className="art art-tokens">
        <div className="art-tokens-head">
          <span className="art-tokens-title">tokens.css</span>
          <span className="art-tokens-tag">v2.4.0</span>
        </div>
        <div className="art-tokens-section">
          <div className="art-tokens-label">color / brand</div>
          <div className="art-swatches">
            {["#0e0e0c", "#ff5a1f", "#ffe3d6", "#1a1a17", "#6b6a64", "#f6f4ef"].map((c, i) => (
              <div key={i} className="art-sw" style={{ "--c": c }}>
                <span className="art-sw-fill" style={{ background: c }}></span>
                <span className="art-sw-name">brand/{i + 1}00</span>
              </div>
            ))}
          </div>
        </div>
        <div className="art-tokens-section">
          <div className="art-tokens-label">space / scale</div>
          <div className="art-spaces">
            {[4, 8, 12, 20, 32, 48, 80].map((n, i) => (
              <div key={i} className="art-space">
                <span className="art-space-bar" style={{ width: n }}></span>
                <span className="art-space-num">{n}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="art-tokens-section">
          <div className="art-tokens-label">type / display</div>
          <div className="art-type">
            <span style={{ fontSize: 36 }}>Aa</span>
            <span style={{ fontSize: 24 }}>Aa</span>
            <span style={{ fontSize: 18 }}>Aa</span>
            <span style={{ fontSize: 14 }}>Aa</span>
          </div>
        </div>
      </div>
    );
  }
  
  if (index === 2) {
    // Brand — wordmark composition
    return (
      <div className="art art-brand">
        <div className="art-brand-mark">
          <svg viewBox="0 0 200 200" width="100%" height="100%">
            <defs>
              <linearGradient id="bg1" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor="#ff5a1f" />
                <stop offset="1" stopColor="#e0480f" />
              </linearGradient>
            </defs>
            <circle cx="100" cy="100" r="92" fill="url(#bg1)" />
            <path d="M52 130 L100 50 L148 130 Z" fill="#0e0e0c" />
            <circle cx="100" cy="105" r="14" fill="#ff5a1f" />
          </svg>
        </div>
        <div className="art-brand-words">
          <div className="art-brand-line" style={{ fontStyle: "italic", fontWeight: 400 }}>halt</div>
          <div className="art-brand-line" style={{ letterSpacing: "-0.06em" }}>HALT</div>
          <div className="art-brand-line" style={{ fontWeight: 700, fontStretch: "condensed" }}>HALT.</div>
        </div>
        <div className="art-brand-foot">
          <span>Wordmark · 03 routes</span>
          <span>↑ approved</span>
        </div>
      </div>
    );
  }
  
  // Creative direction — review board
  return (
    <div className="art art-review">
      <div className="art-review-head">
        <span>Friday review</span>
        <span className="kbd">⌘⇧R</span>
      </div>
      <div className="art-review-grid">
        {[
          { label: "Onboarding · v3", state: "approved" },
          { label: "Empty states", state: "review" },
          { label: "Marketing site", state: "wip" },
          { label: "Iconography", state: "approved" },
          { label: "Mobile nav", state: "blocked" },
          { label: "Pricing page", state: "review" },
        ].map((c, i) => (
          <div key={i} className={`art-review-card art-review-${c.state}`}>
            <div className="art-review-thumb" />
            <div className="art-review-meta">
              <span>{c.label}</span>
              <span className="art-review-state">{c.state}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function ServiceScene({ item, index }) {
  const isDark = item.accent === "dark";
  const flip = index % 2 === 1;
  
  return (
    <section
      id={index === 0 ? "services" : undefined}
      className={`service ${isDark ? "dark" : ""}`}
    >
      <div className="container service-inner">
        <div className="service-meta" data-reveal>
          <span className="service-num">{item.n}</span>
          <span className="eyebrow">Service · what I do</span>
        </div>
        <div className={`service-grid ${flip ? "flip" : ""}`}>
          <div className="service-text" data-reveal style={{ "--reveal-delay": "100ms" }}>
            <h2 className="display service-title">{item.title}</h2>
            <p className="service-lede">{item.lede}</p>
            <div className="service-tags">
              {item.tags.map((t, i) => (
                <span key={i} className="service-tag">{t}</span>
              ))}
            </div>
            <a href="#contact" className={`btn ${isDark ? "btn-primary" : "btn-ghost"}`} style={{ marginTop: 28 }}>
              Discuss a {item.title.toLowerCase()} engagement <Arrow />
            </a>
          </div>
          <div className="service-art" data-reveal style={{ "--reveal-delay": "200ms" }} data-parallax="0.05">
            <ServiceArt index={index} dark={isDark} />
          </div>
        </div>
      </div>
    </section>
  );
}

export function Services() {
  const items = [
    {
      n: "01",
      title: "Product design",
      lede: "End-to-end interface and interaction design for software people actually use every day.",
      tags: ["Discovery", "IA & flows", "UI systems", "Prototyping"],
      accent: "light",
    },
    {
      n: "02",
      title: "Design systems",
      lede: "Token-driven libraries that survive teams of one becoming teams of fifty. Code-aware from day zero.",
      tags: ["Tokens", "Components", "Documentation", "Governance"],
      accent: "dark",
    },
    {
      n: "03",
      title: "Brand & identity",
      lede: "Wordmarks, type systems and motion identities for software brands that want to feel like a publication.",
      tags: ["Wordmarks", "Type systems", "Motion", "Guidelines"],
      accent: "light",
    },
    {
      n: "04",
      title: "Creative direction",
      lede: "Sitting in as fractional design lead. Hiring, reviewing, shaping the visual culture of a young product org.",
      tags: ["Hiring", "Reviews", "Roadmap", "Mentorship"],
      accent: "dark",
    },
  ];
  
  return (
    <>
      {items.map((s, i) => (
        <ServiceScene key={s.n} item={s} index={i} />
      ))}
    </>
  );
}
